module.exports = __webpack_public_path__ + "static/events_inverse-ed5d24b08b0633f2832a2016ae61158c.png";